export const EXCMRELATIONSUSERDATA_DELETE_RESET = 'EXCMRELATIONSUSERDATA_DELETE_RESET'
export const EXCMRELATIONSUSERDATA_DELETE_SET_ERROR = 'EXCMRELATIONSUSERDATA_DELETE_SET_ERROR'
export const EXCMRELATIONSUSERDATA_DELETE_SET_DELETED = 'EXCMRELATIONSUSERDATA_DELETE_SET_DELETED'
export const EXCMRELATIONSUSERDATA_DELETE_TOGGLE_LOADING = 'EXCMRELATIONSUSERDATA_DELETE_TOGGLE_LOADING'
